module.exports = __webpack_public_path__ + "static/media/balmain-1.7856027c.jpg";